const SUPPORT = [
  {
    label: "For your staff",
    title: "Brew guidance at your bar",
    body:
      "We sit down with your baristas over the coffee you have chosen: dose, grind, water and timings, written down so it survives a busy Saturday and a new starter. When the lot changes, we come back and dial it in again.",
    icon: "ri-book-open-line",
    image: `${import.meta.env.BASE_URL}localized/editorial-pourover-01.jpg`,
    alt: "A pour-over being brewed at the counter",
  },
  {
    label: "For your menu",
    title: "The rotating lots, as they land",
    body:
      "Your cafe is offered the same single-origin lots our retail bags come from, in the same weeks they land. The coffee on your guest bar is the coffee people have just read about — and the bags on your shelf are the ones they can take home.",
    icon: "ri-plant-line",
    image: `${import.meta.env.BASE_URL}localized/offering-cafe-01.jpg`,
    alt: "The counter at the Meridian cafe",
  },
];

export default function WithTheBeans() {
  return (
    <section className="w-full bg-background-50 py-24 md:py-32 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16 reveal">
          <span className="text-xs tracking-[0.35em] uppercase text-accent-700">Alongside The Beans</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-950 mt-4 leading-tight">
            What arrives with <em>the order.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {SUPPORT.map((s, idx) => (
            <article
              key={s.title}
              className="group relative flex flex-col bg-background-100 rounded-lg overflow-hidden reveal border border-background-200/60 hover:border-accent-400 transition-colors"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-1000 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 text-[10px] tracking-[0.35em] uppercase bg-background-50 text-primary-900 px-3 py-1.5 rounded-full">
                  {s.label}
                </span>
              </div>
              <div className="p-7 flex-1 flex flex-col">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-5">
                  <i className={`${s.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-2xl text-primary-950 mb-3">{s.title}</h3>
                <p className="text-foreground-700 text-sm leading-relaxed flex-1">{s.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
